export default "__VITE_ASSET__DhPydQM0__"